// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBm4MZTmHDcb98Fks6CbD4j2aFtU4MXx38",
  authDomain: "dashacake-8df91.firebaseapp.com",
  projectId: "dashacake-8df91",
  storageBucket: "dashacake-8df91.firebasestorage.app",
  messagingSenderId: "677170779143",
  appId: "1:677170779143:web:1c71c252d64b3f51dc06a2",
  measurementId: "G-KZHLPDBV2F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);